import { NavLink, Navigate, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import { useContext, useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import { Data } from "../../Data";
import { useNavCounts } from "../utils/useNavCounts";
import useBodyLock from "../utils/useBodyLock";
import LegalInfo from "./LegalInfo";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogBody,
    DialogCloseButton,
} from "../../components/ui/dialog";

const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[18px] h-[18px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75" />
    </svg>
);

const DocumentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[18px] h-[18px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
    </svg>
);

const ChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[18px] h-[18px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
    </svg>
);

const PersonIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[18px] h-[18px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
    </svg>
);

const LogoutIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[16px] h-[16px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
    </svg>
);

const PhoneIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[13px] h-[13px] shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
    </svg>
);

const MailIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[13px] h-[13px] shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
    </svg>
);

const MapPinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[13px] h-[13px] shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
    </svg>
);

function NavBadge({ count }) {
    if (!count || count === 0) return null;
    return (
        <span className="inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold leading-none">
            {count > 99 ? "99+" : count}
        </span>
    );
}

function NavItem({ to, end, icon, label, badge, onClick }) {
    return (
        <NavLink
            to={to}
            end={end}
            onClick={onClick}
            className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive
                    ? "bg-[#082359] text-white"
                    : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
                }`
            }
        >
            {icon}
            <span>{label}</span>
            <NavBadge count={badge} />
        </NavLink>
    );
}

function MobileNavTab({ to, end, icon, label, badge }) {
    const location = useLocation();
    const isActive = end
        ? location.pathname === to
        : location.pathname.startsWith(to);

    return (
        <NavLink
            to={to}
            end={end}
            className="relative flex flex-col items-center justify-center flex-1 h-full gap-0.5 rounded-xl transition-all"
            style={({ isActive: a }) => ({
                color: a ? "#082359" : "#94a3b8",
            })}
        >
            <span className={`relative flex items-center justify-center w-9 h-7 rounded-xl transition-all ${isActive ? "bg-[#082359]/10" : ""}`}>
                <span style={{ color: isActive ? "#082359" : "#94a3b8" }}>{icon}</span>
                {badge > 0 && (
                    <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[14px] h-3.5 px-0.5 rounded-full bg-red-500 text-white text-[8px] font-bold leading-none">
                        {badge > 99 ? "99+" : badge}
                    </span>
                )}
            </span>
            <span className={`text-[9px] font-medium leading-none transition-colors ${isActive ? "text-[#082359]" : "text-slate-400"}`}>
                {label}
            </span>
        </NavLink>
    );
}

const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" className="w-[16px] h-[16px]">
        <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
    </svg>
);

export default function Sidebar() {
    const { state, dispatch: ctxDispatch } = useContext(Data);
    const { userInfo } = state;
    const [desktopOpen, setDesktopOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [infoOpen, setInfoOpen] = useState(false);
    const desktopProfileRef = useRef(null);
    const mobileSheetRef = useRef(null);

    useBodyLock(mobileOpen || desktopOpen || infoOpen);

    const { casesCount, documentsCount, requestsCount, profileCount, userName, userPhone, userEmail, userAddress, loading } =
        useNavCounts();

    useEffect(() => {
        function handleClick(e) {
            if (desktopProfileRef.current && !desktopProfileRef.current.contains(e.target)) {
                setDesktopOpen(false);
            }
            if (mobileSheetRef.current && !mobileSheetRef.current.contains(e.target)) {
                setMobileOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const handleLogout = () => {
        try {
            ctxDispatch({ type: "USER_SIGNOUT" });
            localStorage.removeItem("userInfo");
            window.location.href = "/login?message=logout";
            toast.success("Úspěšně odhlášen!");
        } catch (err) {
            toast.error("Chyba při odhlašování!");
        }
    };

    if (!userInfo) return <Navigate to="/login" />;

    const initials = userName
        ? userName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
        : "U";

    const navItems = [
        { to: "/", end: true, icon: <HomeIcon />, label: "Domů", badge: casesCount },
        { to: "/documents", end: false, icon: <DocumentIcon />, label: "Dokumenty", badge: documentsCount },
        { to: "/requests", end: false, icon: <ChatIcon />, label: "Žádosti", badge: requestsCount },
        { to: "/profile", end: false, icon: <PersonIcon />, label: "Údaje", badge: profileCount },
    ];

    const SidebarContent = () => (
        <div className="flex flex-col h-full">
            <div className="flex items-center h-16 px-4 border-b border-border shrink-0">
                <NavLink to="/">
                    <img src={logo} width="100" alt="De Vries Group logo" />
                </NavLink>
            </div>

            <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1" aria-label="Hlavní navigace">
                {navItems.map((item) => (
                    <NavItem key={item.to} {...item} />
                ))}
            </nav>

            <div className="px-3 py-4 border-t border-border shrink-0" ref={desktopProfileRef}>
                <div className="relative">
                    <button
                        onClick={() => setDesktopOpen((v) => !v)}
                        aria-haspopup="true"
                        aria-expanded={desktopOpen}
                        className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                    >
                        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#082359] text-white text-xs font-semibold shrink-0">
                            {loading ? <PersonIcon /> : initials}
                        </span>
                        <span className="flex-1 text-left min-w-0">
                            {loading ? (
                                <>
                                    <span className="block h-2.5 w-28 rounded bg-muted animate-pulse mb-1.5" />
                                    <span className="block h-2 w-36 rounded bg-muted animate-pulse opacity-60" />
                                </>
                            ) : (
                                <>
                                    <span className="block text-sm font-medium text-foreground truncate leading-tight">
                                        {userName || "Uživatel"}
                                    </span>
                                    {[userPhone, userEmail, userAddress].filter(Boolean).length > 0 && (
                                        <span className="block text-[10.5px] text-muted-foreground truncate leading-tight mt-0.5">
                                            {[userPhone, userEmail, userAddress].filter(Boolean).join(" · ")}
                                        </span>
                                    )}
                                </>
                            )}
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className={`w-3.5 h-3.5 shrink-0 transition-transform ${desktopOpen ? "rotate-180" : ""}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg>
                    </button>

                    {desktopOpen && (
                        <div className="absolute bottom-full left-0 right-0 mb-1 bg-popover border border-border rounded-lg shadow-lg overflow-hidden z-50">
                            <NavLink
                                to="/profile"
                                onClick={() => setDesktopOpen(false)}
                                className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground hover:bg-accent transition-colors"
                            >
                                <PersonIcon />
                                Upravit údaje
                            </NavLink>
                            <hr className="border-border" />
                            <button
                                onClick={() => { setDesktopOpen(false); setInfoOpen(true); }}
                                className="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-foreground hover:bg-accent transition-colors"
                            >
                                <InfoIcon />
                                Informace o nás
                            </button>
                            <hr className="border-border" />
                            <button
                                onClick={handleLogout}
                                className="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-destructive hover:bg-red-50 transition-colors"
                            >
                                <LogoutIcon />
                                Odhlásit se
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <>
            <aside className="app-sidebar hidden lg:flex" aria-label="Postranní panel">
                <SidebarContent />
            </aside>

            <div className="mobile-top-stripe">
                <div className="mobile-top-stripe-inner">
                    <NavLink to="/" className="flex items-center">
                        <img src={logo} alt="De Vries Group" className="h-[30px] w-auto object-contain" />
                    </NavLink>

                    <button
                        onClick={() => setMobileOpen((v) => !v)}
                        aria-label="Profil"
                        aria-haspopup="true"
                        aria-expanded={mobileOpen}
                        className="flex items-center gap-2 pl-2 pr-1 py-1 rounded-full transition-all"
                        style={{
                            background: mobileOpen ? "rgba(8,35,89,0.08)" : "transparent",
                        }}
                    >
                        <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-white text-[10px] font-bold transition-all shrink-0 ${mobileOpen ? "ring-2 ring-[#082359]/25 ring-offset-1" : ""
                            }`} style={{ background: "#082359" }}>
                            {loading ? <PersonIcon /> : initials}
                        </span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            strokeWidth={2.2} stroke="currentColor"
                            className={`w-3 h-3 text-[#082359]/60 transition-transform duration-200 ${mobileOpen ? "rotate-180" : ""}`}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg>
                    </button>
                </div>
            </div>

            {mobileOpen && (
                <div ref={mobileSheetRef}>
                    <div
                        className="profile-sheet-backdrop"
                        onClick={() => setMobileOpen(false)}
                        aria-hidden="true"
                    />
                    <div className="profile-sheet">
                        <div className="flex items-center gap-3 px-4 pt-4 pb-3.5">
                            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full text-white text-sm font-semibold shrink-0" style={{ background: "#082359" }}>
                                {loading ? <PersonIcon /> : initials}
                            </span>
                            <div className="min-w-0 flex-1">
                                {loading ? (
                                    <span className="block h-3 w-28 rounded bg-muted animate-pulse mb-1" />
                                ) : (
                                    <p className="text-[13px] font-semibold text-foreground leading-snug truncate">
                                        {userName}
                                    </p>
                                )}
                                <div className="mt-1 space-y-[3px]">
                                    {userPhone && (
                                        <div className="flex items-center gap-1.5">
                                            <PhoneIcon />
                                            <span className="text-[11px] text-muted-foreground truncate">{userPhone}</span>
                                        </div>
                                    )}
                                    {userEmail && (
                                        <div className="flex items-center gap-1.5">
                                            <MailIcon />
                                            <span className="text-[11px] text-muted-foreground truncate">{userEmail}</span>
                                        </div>
                                    )}
                                    {userAddress && (
                                        <div className="flex items-center gap-1.5">
                                            <MapPinIcon />
                                            <span className="text-[11px] text-muted-foreground truncate">{userAddress}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="h-px mx-4 bg-black/[0.06]" />

                        <NavLink
                            to="/profile"
                            onClick={() => setMobileOpen(false)}
                            className="flex items-center gap-2.5 px-4 py-3 text-[13px] font-medium text-foreground hover:bg-black/[0.04] active:bg-black/[0.07] transition-colors"
                        >
                            <PersonIcon />
                            Upravit údaje
                        </NavLink>

                        <div className="h-px mx-4 bg-black/[0.06]" />

                        <button
                            onClick={() => { setMobileOpen(false); setInfoOpen(true); }}
                            className="flex items-center gap-2.5 w-full px-4 py-3 text-[13px] font-medium text-foreground hover:bg-black/[0.04] active:bg-black/[0.07] transition-colors"
                        >
                            <InfoIcon />
                            Informace o nás
                        </button>

                        <div className="h-px mx-4 bg-black/[0.06]" />

                        <button
                            onClick={handleLogout}
                            className="flex items-center gap-2.5 w-full px-4 py-3 text-[13px] font-medium text-red-500 hover:bg-red-50/50 active:bg-red-50/80 transition-colors"
                        >
                            <LogoutIcon />
                            Odhlásit se
                        </button>
                        <div className="h-1" />
                    </div>
                </div>
            )}

            <div className="mobile-bottom-nav">
                <div className="mobile-bottom-nav-inner">
                    {navItems.map((item) => (
                        <MobileNavTab
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            icon={item.icon}
                            label={item.label}
                            badge={item.badge}
                        />
                    ))}
                </div>
            </div>

            <Dialog open={infoOpen} onOpenChange={setInfoOpen}>
                <DialogContent size="md">
                    <DialogHeader className="!flex-row !space-y-0 items-center justify-between">
                        <DialogTitle>Informace o nás</DialogTitle>
                        <DialogCloseButton className="static opacity-100 hover:opacity-70 shrink-0" />
                    </DialogHeader>
                    <DialogBody>
                        <LegalInfo variant="modal" />
                    </DialogBody>
                </DialogContent>
            </Dialog>
        </>
    );
}
